// https://tech.smartcamp.co.jp/entry/2019/08/08/185351

export default {
  install(app) {
    const globalProperties = app.config.globalProperties;
    globalProperties.$intervals = [];
    globalProperties.$setInterval = (func, intervalMilliSec) => {
      if (typeof import.meta.env.VITE_DISABLE_SET_INTERVAL !== "undefined") {
        return null;
      }
      const id = setInterval(() => {
        if (document.visibilityState === "visible") {
          func();
        }
      }, intervalMilliSec);
      globalProperties.$intervals.push(id);
      return id;
    };
    globalProperties.$clearInterval = id => {
      clearInterval(id);
      globalProperties.$intervals = globalProperties.$intervals.filter(i => i !== id);
    };
    globalProperties.$clearAllIntervals = () => {
      globalProperties.$intervals.forEach(clearInterval);
      globalProperties.$intervals = [];
    };
  }
};
